import * as stylex from "@stylexjs/stylex";
import { CopyIcon } from "../icons.ts";
import { Button, type ButtonProps } from "./Button.tsx";
export interface CopyButtonProps extends Omit<ButtonProps, "onClick" | "icon" | "children" | "status" | "successLabel" | "errorLabel"> {
  value: string;
  label?: string;
  /** Icon-only variant for dense layouts. */
  compact?: boolean;
}
export function CopyButton({
  value,
  label = "Copy",
  compact = false,
  variant = "secondary",
  size = "sm",
  ...rest
}: CopyButtonProps) {
  return <Button {...rest} variant={variant} size={size} iconOnly={compact} aria-label={compact ? label : undefined}
  // The button tracks the clipboard write: "Copied" when it lands, "Couldn't copy" if it's refused.
  onClick={() => navigator.clipboard.writeText(value)} successLabel="Copied" errorLabel="Couldn't copy" icon={<span className="x78zum5">
          <CopyIcon size={14} />
        </span>}>
      {label}
    </Button>;
}